// pages/StockAnalysis.jsx
import IntroBlock from "./IntroBlock";
import CoreRatios from "./CoreRatios";
import Profitability from "./Profitability";
import GrowthBlock from "./GrowthBlock";
import ShareholderReturns from "./ShareholderReturns";
import ClosingBlock from "./ClosingBlock";
import { BankingBlock, CorporateBlock, InsuranceBlock } from "./SectorBlock";

export default function StockAnalysis({ data }) {
  const { company, sector, type } = data;

  //console.log('company type=====:', type)


  return (
    <>
        <h2 className="text-2xl font-semibold py-4">{company} Stock Price Analysis and Quick Research Report. Is {company} an attractive stock to invest in?</h2>
        <IntroBlock company={company} sector={sector} />
        <CoreRatios company={company} ratios={data.ratios} />
        {data.profitability && ( <Profitability company={company} data={data.profitability} /> )}
        <GrowthBlock company={company} growth={data.salesGrowth} />
        {data.shareholderReturns && ( <ShareholderReturns company={company} data={data.shareholderReturns} />)}

        {/* {type === "bank" ? (
            <BankingBlock company={company} data={data.bankingMetrics} />
        ) : (
            <CorporateBlock company={data.company} data={data.corporateMetrics} />
        )} */}
        {type === "bank" && (
          <BankingBlock company={company} data={data.bankingMetrics} />
        )}

        {type === "insurance" && (
          <InsuranceBlock company={company} data={data.insuranceMetrics} />
        )}

        {type === "corporate" && (
          <CorporateBlock company={company} data={data.corporateMetrics} />
        )}


        <ClosingBlock company={company} />
    </>
  );
}
